import React from 'react';
import { CommonIconProps } from './Icon';

const BuildingIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 3C11 2.44772 11.4477 2 12 2H19C19.5523 2 20 2.44772 20 3V22H13V19H11V22H4V8C4 7.44772 4.44772 7 5 7H11V3ZM13 4H18V7H13V4ZM6 9H11V12H6V9ZM18 9H13V12H18V9ZM13 14H18V17H13V14ZM11 14H6V17H11V14Z"
      fill={color}
    />
  </>
);

export default BuildingIcon;
